<template>
  <div :class="classes()">
    <div :class="`${el}__profile`" @mouseenter="isActive = true" @mouseleave="isActive = false">
      <div :class="`${el}__profileInner`">
        <div v-if="userStatus === 'success' && !onlyLogoutLink" :class="`${el}__initialsCircle`">
          {{ initials }}
        </div>
        <div v-else :class="`${el}__initialsCircle`">
          <Icon name="user-line" size="l" color="primaryBlue" />
        </div>
        <Copy
          v-if="$matchMedia.l"
          element="span"
          :staticClass="`${el}__dropdown`"
          size="s"
          color="primaryBlue"
          bold
        >
          {{ $t('metaNav.profile') }}
          <Icon name="arrow-down-s-line" size="l" color="primaryBlue" />
        </Copy>
      </div>

      <div :class="`${el}__popover`">
        <div :class="`${el}__popoverInner`">
          <div :class="`${el}__popoverInfo`" v-if="!onlyLogoutLink">
            <Copy element="div" size="s" centered noWrap color="tertiaryLight">
              {{ $t('metaNav.loggedInAs') }}
            </Copy>
            <Copy element="div" size="m" bold centered noWrap color="tertiaryDark">
              {{ user.firstname }} {{ user.lastname }}
            </Copy>
          </div>
          <ul :class="`${el}__list`">
            <li :class="`${el}__listItem`" v-if="!onlyLogoutLink">
              <Link
                :class="`${el}__listItemLink`"
                :to="ROUTE_PROFILE"
                weight="regular"
                :size="$matchMedia.l ? 's' : 'm'"
                @click="close"
              >
                <Icon
                  :class="`${el}__listItemLinkIcon`"
                  color="primaryBlue"
                  name="contacts-book-line"
                />
                {{ $t('metaNav.myProfile') }}
              </Link>
            </li>
            <li :class="!onlyLogoutLink ? `${el}__listItem` : ''">
              <Link
                :class="`${el}__listItemLink`"
                weight="regular"
                :size="$matchMedia.l ? 's' : 'm'"
                @click="logout"
              >
                <Icon
                  :class="`${el}__listItemLinkIcon`"
                  color="primaryBlue"
                  name="logout-box-line"
                />
                {{ $t('metaNav.logout') }}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Link :to="EXTERNAL_ROUTE_HOME" :class="`${el}__logoLink`" external target="">
      <img :class="`${el}__logo`" src="@/assets/logo/logo.svg" />
    </Link>

    <div
      v-if="!$matchMedia.l && !onlyLogoutLink"
      :class="`${el}__burgerNav`"
      @click="$emit('toggleMobileNavigation')"
    >
      <span />
      <span />
      <span />
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Link from '@/objects/Link';
import Icon from '@/objects/Icon';
import { ROUTE_LOGIN, ROUTE_PROFILE, EXTERNAL_ROUTE_HOME } from '@/constants/routes';
import { AUTH_LOGOUT } from '@/store/actions/auth';

import { mapFieldsUser } from '@/store/mapFields';
import initialsMixin from '@/mixins/initials';

export default {
  name: 'MetaNav',
  mixins: [initialsMixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    onlyLogoutLink: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Link,
    Icon,
    Copy,
  },
  computed: {
    ...mapFieldsUser(['userStatus']),
  },
  data() {
    return {
      ROUTE_PROFILE,
      EXTERNAL_ROUTE_HOME,
      el: 'c-metaNav',
      isActive: false,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--popoverOpen`]: this.isActive,
          [`${el}--open`]: this.open,
        };
      },
    };
  },
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(this.redirectToLogin).catch(this.redirectToLogin);
    },
    redirectToLogin() {
      this.$router.push(ROUTE_LOGIN);
    },
    close() {
      if (!this.$matchMedia.l) {
        this.isActive = false;
      }
    },
  },
};
</script>
